import {
    COUNTRIES_INFO,
    PEER_INFO,
    NOTIFY_PENDING,
    POSTAL_CODE_CACHE
} from './mutation-types'

export default {
    [COUNTRIES_INFO](state, payload) {
        state.countries = payload.countries
        state.states = payload.divisions
    },
    
    [PEER_INFO](state, payload) {
        state.ownerTypes = payload.peerOwnerTypes
        state.ratingSystems = payload.ratingSystems
        
        state.teamRoles = payload.peerTeamRoles
        state.teamRoles.push('Other')
        
        state.peerCampusUseTypes = payload.peerCampusUseTypes
        state.peerUtilityUseTypes = payload.peerUtilityUseTypes
        state.peerTransitUseTypes = payload.peerTransitUseTypes
    },
    
    [NOTIFY_PENDING](state, payload) {
        state.notifyPending = payload
    },
    
    [POSTAL_CODE_CACHE](state, payload) {
        let key = payload.input
        key = key.country+':'+key.state+':'+key.postalCode
        
        state.postalCodes[key] = payload.output
    }
}
